import merge from 'lodash/merge';
import React from 'react';
import {
  and,
  showAsRequired,
  isDescriptionHidden,
  isEnumControl,
  optionIs,
  rankWith
} from '@jsonforms/core';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Hidden,
  Radio,
  RadioGroup
} from '@mui/material';
import { useFocus } from '@jsonforms/material-renderers';
import { withJsonFormsEnumProps } from '@jsonforms/react';

const RadioGroupField = props => {
  const [focused, onFocus, onBlur] = useFocus();
  const {
    config,
    id,
    label,
    required,
    description,
    errors,
    data,
    visible,
    options,
    handleChange,
    path,
    enabled
  } = props;
  const isValid = errors.length === 0;
  const appliedUiSchemaOptions = merge(
    {},
    config,
    props.uischema.options
  );
  const showDescription = !isDescriptionHidden(
    visible,
    description,
    focused,
    appliedUiSchemaOptions.showUnfocusedDescription
  );
  const onChange = (_ev, value) => handleChange(path, value);

  return (
    <Hidden xsUp={!visible}>
      <FormControl
        component={'fieldset'}
        fullWidth={!appliedUiSchemaOptions.trim}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        <FormLabel
          sx={{ color: 'black', fontWeight: 'bold' }}
          htmlFor={id}
          error={!isValid}
          component={'legend'}
          required={showAsRequired(required,
            appliedUiSchemaOptions.hideRequiredAsterisk)}
        >
          {label}
        </FormLabel>

        <RadioGroup
          id={id}
          value={props.data ?? ''}
          onChange={onChange}
          row={true}
        >
          {options.map(option => (
            <FormControlLabel
              value={option.value}
              key={option.label}
              control={<Radio checked={data === option.value} />}
              label={option.label}
              disabled={!enabled}
            />
          ))}
        </RadioGroup>
        <FormHelperText error={!isValid}>
          {!isValid ? errors : showDescription ? description : null}
        </FormHelperText>
      </FormControl>
    </Hidden>
  );
};


export const RadioGroupFieldControl = props => <RadioGroupField {...props} />;

export const RadioGroupFieldControlTester = rankWith(
  21,
  and(isEnumControl, optionIs('format', 'radio'))
);

export default withJsonFormsEnumProps(RadioGroupFieldControl);


